export const phoneNumberParse = (phoneNumber: string) => {
  const newPhoneNumber = phoneNumber.replace(/-/g, "");

  return newPhoneNumber.replace(/\./g, "");
};

export default {};
